// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_PRODUCT_REQUEST = 'SHOP_PRODUCT_REQUEST';
export const SHOP_PRODUCT_SUCCESS = 'SHOP_PRODUCT_SUCCESS';
export const SHOP_PRODUCT_FAILURE = 'SHOP_PRODUCT_FAILURE';
export const SHOP_PRODUCT_CLEAR = 'SHOP_PRODUCT_CLEAR';


/**
 * Запрос подробной информации по товару
 */
export const productFetch = (slug: string) => async (dispatch: Function) => {
  dispatch(action(SHOP_PRODUCT_REQUEST, slug));
  try {
    const res = await shopApiRequest(`products/${slug}`, 'get');
    const data = path(['data', 'data'], res) || {};
    dispatch(action(SHOP_PRODUCT_SUCCESS, data));
    return { errStatus: 0 };
  } catch (error) {
    const status = path(['response', 'status'], error);
    dispatch(action(SHOP_PRODUCT_FAILURE, {
      err: 'Запрос товара каталога не удался',
      slug,
      error,
    }));
    return { errStatus: status };
  }
};
